import { render, staticRenderFns } from "./Manage-Previous-Vendor.vue?vue&type=template&id=d23ad1a6&"
import script from "./Manage-Previous-Vendor.vue?vue&type=script&lang=js&"
export * from "./Manage-Previous-Vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports